import React, { useContext, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Checkbox } from "@material-ui/core";
import TabsPanel from "@components/TabsPanel";
import Typography from "@components/Typography";
import MarketActiveOrders from "./MarketActiveOrders";
import Button from "@components/Button";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import MarketYourTransaction from "./MarketYourTransaction";
import { StatsContext } from "@context/statsContext";
import clsx from "clsx";
import RecentMarketTrades from "./RecentMarketTrades";
import MarketAssests from "./MarketAssests";
import { Context } from "@features/Wallets/context/context";
import order from "@api/order";
import { MarketContext } from "@context/MarketContext";
import { notification } from "@core/helper/notificationHelper";

const MarketTable = (props) => {
  const { recentMarket, height, emptySize = "default" } = props;
  const classes = useStyles(props);
  const [alignment, setAlignment] = useState("you");
  const [InventoryWallets, setInventoryWallets] = useState(false);
  const { state } = useContext(Context);
  const { statsState } = useContext(StatsContext);
  const market = useContext(MarketContext);

  const handleChange = (event) => {
    setInventoryWallets(event.target.checked);
  };
  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const cancelAllOrders = () => {
    order
      .cancelAllOrders()
      .then((data) => {
        notification("", "success", data?.message);
        market.setForceUpdate(!market.forceUpdate);
      })
      .catch((data) => {
        notification(
          "",
          "danger",
          !!data && !!data?.message ? data?.message : "SERVER ERROR"
        );
      });
  };

  const checkAlignment = () => {
    if (alignment === "you") {
      return (
        <MarketYourTransaction
          className={classes.marketTable}
          pageSize={10}
          pageNumber={0}
          pagination={false}
          emptySize={emptySize}
        />
      );
    } else if (alignment === "market") {
      return (
        <RecentMarketTrades
          className={clsx(classes.marketTable, classes.recentMarketContainer)}
          pageSize={10}
          pageNumber={0}
          pagination={false}
        />
      );
    }
  };
  const tabs = [
    {
      label: __t("Active orders"),
      component: (
        <div className={classes.tableContainer}>
          <MarketActiveOrders
            className={classes.marketTable}
            pageSize={10}
            pageNumber={0}
            pagination={false}
            emptySize="small"
          />
        </div>
      ),
      action: (
        <div className={classes.extraTextContainer}>
          {market.orderLength > 0 && (
            <Button
              size="small"
              startIcon={<span className={clsx("icon-x", classes.iconX)} />}
              onClick={cancelAllOrders}
            >
              <Typography
                variant="3xs"
                color="secondary.tint40"
                isBold
                size={emptySize}
              >
                {__t("Terminate Active Orders")}
              </Typography>
            </Button>
          )}
        </div>
      ),
    },
    {
      label: __t("Trading history"),
      component: (
        <div className={classes.tableContainer}>
          {recentMarket ? (
            checkAlignment()
          ) : (
            <MarketYourTransaction
              className={classes.marketTable}
              pageSize={10}
              pageNumber={0}
              pagination={false}
              emptySize={emptySize}
              emptySize="small"
            />
          )}
        </div>
      ),

      action: recentMarket && (
        <div className={classes.extraTextContainer}>
          <ToggleButtonGroup
            className={classes.switchBtn}
            value={alignment}
            exclusive
            onChange={handleAlignment}
          >
            <ToggleButton title={__t("Your Transactions")} value="you">
              <Typography variant="3xs">{__t("Your Transactions")}</Typography>
            </ToggleButton>

            <ToggleButton title={__t("Market Transactions")} value="market">
              <Typography variant="3xs">
                {__t("Market Transactions")}
              </Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      ),
    },
    {
      label: __t("Assets"),
      component: (
        <div className={classes.tableContainer}>
          <MarketAssests
            className={classes.marketTable}
            pageSize={10}
            pageNumber={0}
            pagination={false}
            type="marketPage"
            iconSize="small"
            wallets={
              InventoryWallets
                ? state.wallet.filter((item) => item.totalBalance > 0)
                : state.wallet
            }
            stats={statsState.stats}
            emptySize="small"
          />
        </div>
      ),
      action: (
        <div className={classes.extraTextContainer}>
          <Checkbox
            checked={InventoryWallets}
            onChange={handleChange}
            size="small"
          />
          <Typography
            variant="3xs"
            color="secondary.tint40"
            isBold
            size="small"
          >
            {__t("Show Only Wallets With Inventory")}
          </Typography>
        </div>
      ),
    },
  ];

  return (
    <TabsPanel
      tabs={tabs}
      className={classes.appBar}
      smallTabs={true}
      size="small"
    />
  );
};

export default MarketTable;
